import Tooltip from '@mui/material/Tooltip'
import { useState } from 'react'
import { reExportedColors } from './index'

const position = {
  right: [0, -10],
  top: [0, -10],
  'top-end': [10, 0],
  bottom: [0, 0],
  left: [-30, 30]
}

export default function ITooltip ({
  children,
  content,
  placement,
  arrow,
  className,
  showTooltip
}) {
  const [isDragging, setIsDragging] = useState(false)
  const [onHover, setOnHover] = useState(false)
  const incomingShowTooltip = showTooltip === undefined ? true : showTooltip

  return (
    <Tooltip
      arrow={arrow}
      className={className}
      disableInteractive
      open={!isDragging && onHover && incomingShowTooltip}
      placement={placement}
      title={content}
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: { offset: position[placement] || [0, 0] }
          },
          {
            name: 'flip',
            enabled: false
          }
        ]
      }}
      componentsProps={{
        arrow: {
          sx: { color: reExportedColors.DARK_GREY }
        },
        tooltip: {
          sx: {
            backgroundColor: reExportedColors.DARK_GREY,
            boxShadow: arrow ? undefined : '0px 0px 3px #0000009F',
            fontSize: 11,
            fontWeight: 'normal'
          }
        }
      }}
    >
      <div
        onDragStart={() => setIsDragging(true)}
        onDragEnd={() => setIsDragging(false)}
        onMouseOver={() => setOnHover(true)}
        onMouseLeave={() => setOnHover(false)}
      >
        {children}
      </div>
    </Tooltip>
  )
}
